<template>
    <div class="body-lp">
        <top-bar-sub-entel-esp/>
        <div class="site-content">
            <div class="container">
                <div class="row justify-content-center">
                    <div
                        :class="'col-md-6'"
                        :style="{
                    'max-width': '500px' ,
                    'margin':'auto'
                    }"
                    >
                        <br><br><br>
                        <h2 class="checkout-title-felicitaciones-lp font-weight-light text-center">Muchas gracias por su registro, en un momento será <b>redireccionado.</b></h2>
                        <br><br><br><br><br><br><br><br><br><br><br><br>
                        <div class="text-center">
                            <label class="label-lp"><b style="font-weight: 900">Precio $990 (IVA Incl.)</b><br>Renovación automática semanal.</label>
                            <br>
                            <label class="label-lp"><b style="font-weight: 900">Importante:</b>  La suscripción a este
                                servicio representa un cobro
                                adicional con cargo a tu boleta o
                                saldo Entel.</label>
                            <br>
                            <br>
                            <label class="label-lp">Para desuscribir, envía SALIR al 2488</label>
                            <br>
                            <a style="font-size: medium; color: #525252;" @click="condiciones"><u><b>Términos y Condiciones</b></u></a>
                            <br>
                        </div>
                        <br><br>
                        <img
                            class="img-fluid mx-auto w-100"
                            :src="require('@/assets/galerias/fondo.png')"
                            alt
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
body {
    background-color: white;
}
</style>
<script>
import TopBarSubEntelEsp from "../components/TopBarSubEntelEsp.vue";
export default {
    name: "LpEntelFelicitaciones",
    components: {
        TopBarSubEntelEsp,
    },
    directives: {
    },
    computed: {
    },
    watch: {

    },
    data() {
        return {
            telefono: this.$route.params.msisdn,
        };
    },
    methods: {
        proxyUser(){
            window.location.href = "https://cms.topclass.academy/thinkific/auth?msisdn="+ this.telefono
        },
    },
    mounted() {
        if (this.telefono) {
            setTimeout(() => {
                this.proxyUser();
            }, 3000);
        }
    },
    created() {
        if (!this.telefono) {
            this.$router.push({ name: "error404" });
        }
    },
};
</script>
